import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategoryShowcase() {
  const showcaseCategories = categories.slice(0, 3);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            分类精选
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base">
            探索各个品类的亚洲精品之美
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {showcaseCategories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className="group relative h-72 md:h-80 rounded-xl overflow-hidden cursor-pointer"
            >
              <img
                src={cat.image}
                alt={`${cat.name} - 亚洲精品分类`}
                title={`${cat.name} - ${cat.description}`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm text-white mb-3">
                  <i className={`${cat.icon} text-xl w-5 h-5 flex items-center justify-center`}></i>
                </div>
                <h3 className="text-lg md:text-xl font-heading font-bold text-white mb-1">
                  {cat.name}
                </h3>
                <p className="text-sm text-white/70 line-clamp-2">
                  {cat.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}